import { useTranslation } from 'react-i18next';
import { Button, CheckboxInput, Col, Form, Icon, Input, Row, Section } from 'ui';

export type PasswordLessLoginFormValues = {
  email: string;
  remember: boolean;
};

type P = {
  loading: boolean;
  onNavigateToPrimaryLogin: () => void;
  onSubmit: (data: PasswordLessLoginFormValues) => void;
};

const PasswordLessLoginForm = ({ loading, onNavigateToPrimaryLogin, onSubmit }: P) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();

  const onFinish = (data: PasswordLessLoginFormValues) => {
    onSubmit(data);
  };

  return (
    <Form<PasswordLessLoginFormValues>
      className="onboarding-password-login-form__form"
      form={form}
      initialValues={{ remember: true }}
      onFinish={onFinish}
    >
      <Row align="middle">
        <Col span={24}>
          <Form.Item<PasswordLessLoginFormValues>
            label="Email"
            name="email"
            rules={[
              {
                type: 'email',
              },
              {
                required: true,
                whitespace: true,
              },
            ]}
          >
            <Input autoComplete="email" />
          </Form.Item>
        </Col>
        <Col span={24}>
          <CheckboxInput
            item={{
              label: t('Remember me'),
              name: 'remember',
              valuePropName: 'checked',
            }}
          />
        </Col>
      </Row>
      <Section lineBottom={false} lineTop={false} paddingBottom={false} paddingTop>
        <Row gutter={[0, 'ms']}>
          <Col span={24}>
            <Button block htmlType="submit" loading={loading} type="primary">
              E-mail me a log in link
            </Button>
          </Col>
          <Col span={24}>
            <Button
              block
              icon={<Icon icon="arrow-left-line" />}
              onClick={() => {
                onNavigateToPrimaryLogin();
              }}
            >
              All log in options
            </Button>
          </Col>
        </Row>
      </Section>
    </Form>
  );
};

export default PasswordLessLoginForm;
